/**
 * File to house all of our reusable CTAs until CMS is ready.
 */

/**
 * Contact Support.
 */
export const CTA_CONTACT_SUPPORT = {
  translation: 'my:contactSupportLabel',
  url: '/support',
};
